import { assert } from '../../app/logger.js';
import { PipeableArray } from './pipeable_array.js';

const ArrayCompositionPipeableMixin = PipeableBase =>
  class extends PipeableBase {
    constructor(caster, getCasterData, getCasterDeps, classIdentification) {
      super();

      assert(
        caster instanceof PipeableArray,
        `[data] wrong caster for pipeable composition, got ${caster}`
      );
      this.#caster = caster;

      this.#getData = getCasterData;
      this.#getCasterDeps = getCasterDeps;
      this.#classIdentification = classIdentification;

      this.#itemDataDeps =
        this.getItemDataDeps().length > 0
          ? Object.fromEntries(
              this.getItemDataDeps().reduce(
                (a, v) => a.set(v, this.#onupdate),
                new Map()
              )
            )
          : null;
    }

    pipe(...args) {
      if (!this.hasReceivers()) {
        if (this.#itemDataDeps) {
          this.#caster.pipeItems(this.#itemDataDeps);
        }
        this.#caster.pipe(this.#onupdate);
      }
      return super.pipe(...args);
    }

    unpipe(...args) {
      super.unpipe(...args);
      if (!this.hasReceivers()) {
        this.#caster.unpipe(this.#onupdate);
        if (this.#itemDataDeps) {
          this.#caster.unpipeItems(this.#itemDataDeps);
        }
      }
    }

    get caster() {
      return this.#caster;
    }

    get casterData() {
      return this.#caster.data;
    }

    getData() {
      return this.#getData();
    }

    getItemDataDeps() {
      return this.#getCasterDeps || this.constructor.itemDataDeps;
    }

    toString() {
      return `[${this.#classIdentification}]` || super.toString();
    }

    static itemDataDeps = [];

    #caster;
    #classIdentification;
    #getData;
    #getCasterDeps;
    #itemDataDeps;
    #onupdate = () => {
      this.set(this.getData());
    };
  };

export { ArrayCompositionPipeableMixin };
